import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { IconName } from "@circleco/compass/components/Icon";
import { Icon } from "@circleco/compass/components/Icon";
import { Typography } from "@circleco/compass/components/Typography";

export interface SidebarItemContentProps {
  endContent?: React.ReactNode;
  label: string;
  labelTestId?: string;
  showEndContentOnlyOnHover?: boolean;
  startContent?: React.ReactNode;
  startIcon?: IconName;
}

export const Content = ({
  endContent,
  label,
  labelTestId,
  showEndContentOnlyOnHover = false,
  startContent,
  startIcon,
}: SidebarItemContentProps) => (
  <>
    <div
      className="flex w-full min-w-0 items-center gap-2"
      data-hover-trigger // DO NOT REMOVE. This matches the hover scope class returned by useSidebarNavLinkClass
    >
      {startContent}
      {!startContent && startIcon && <Icon name={startIcon} size="sm" />}
      <Typography
        className="flex-1"
        color="current"
        component="span"
        data-testid={labelTestId}
        truncate
        variant="label-sm"
      >
        {label}
      </Typography>
    </div>

    {endContent && (
      <div
        className={classNames(
          "inline-flex shrink-0 items-center",
          showEndContentOnlyOnHover &&
            "hidden group-hover/sidebar-item:inline-flex group-focus-within/sidebar-item:inline-flex",
        )}
      >
        {endContent}
      </div>
    )}
  </>
);
